let distanceValue;

// Function to calculate and store the distance
function calculateDistance() {
  const element = document.querySelector('.section-title');
  if (element) {
    const rect = element.getBoundingClientRect();
    distanceValue = rect.left; // Store the distance value
  }
}
// Initial calculation of the distance
calculateDistance();

const swiperCarousel = new Swiper('.swiper-carousel', {
  speed: 400,
  //loop: true,
  rewind: true,
  slidesPerView: "auto",
  spaceBetween: 20,
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    750: {
      slidesOffsetBefore: 40,
      spaceBetween: 20,
    },
    990: {
      slidesOffsetBefore: distanceValue,
      spaceBetween: 50,
      slidesOffsetAfter: 50,
    }
  }
});

/*setTimeout(function(){
  
const swiperRelated = new Swiper('.swiper-related', {
  speed: 400,
  //loop: true,
  rewind: true,
  slidesPerView: "auto",
  spaceBetween: 20,
  slidesOffsetBefore: 20,
  slidesOffsetAfter: 20,
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  breakpoints: {
    750: {
      slidesOffsetBefore: 40,
      spaceBetween: 20,
    },
    990: {
      slidesOffsetBefore: distanceValue,
      spaceBetween: 50,
      slidesOffsetAfter: 50,
    }
  }
});

}, 3000);*/

const swiperHeroCarousel = new Swiper('.swiper-hero-carousel', {
  speed: 400,
  loop: true,
  centeredSlides: true,
  slidesPerView: "auto",
  spaceBetween: 0,
  autoplay: {
    delay: 5000,
    pauseOnMouseEnter: true
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  pagination: {
    el: '.swiper-pagination',
    clickable: true,
  },
  breakpoints: {
    990: {
      spaceBetween: 20
    }
  }
});

const swiperHeroCarouselWide = new Swiper('.swiper-hero-carousel-wide', {
  speed: 600,
  loop: true,
  effect: 'fade',
  fadeEffect: {
    crossFade: true
  },
  autoplay: {
    delay: 4000,
  },
  //rewind: true,
  slidesPerView: "auto",
  pagination: {
    el: '.swiper-pagination',
    type: 'fraction',
  },
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  }
});

/* Mailchimp API Form */

(() => {
  const API_URL = 'https://mailchimp-subscribe.vercel.app/api/subscribe';

  // Helper: validate email format
  function validateEmail(email) {
    const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return re.test(email);
  }

  // Attach submit handler to all forms with class "mc-subscribe-form"
  function setupForm(form) {
    const messageEl = form.querySelector('.mc-message');
    const emailInput = form.querySelector('input[name="email"]');
    const gdprCheckbox = form.querySelector('input[name="gdpr"]');
    const submitBtn = form.querySelector('input[type="submit"]');

    form.addEventListener('submit', async (e) => {
      e.preventDefault();

      messageEl.textContent = '';
      messageEl.style.color = '';

      const email = emailInput.value.trim();
      const gdprChecked = gdprCheckbox.checked;

      if (!email) {
        messageEl.textContent = 'Please enter your email address.';
        messageEl.style.color = 'red';
        return;
      }

      if (!validateEmail(email)) {
        messageEl.textContent = 'Please enter a valid email address.';
        messageEl.style.color = 'red';
        return;
      }

      if (!gdprChecked) {
        messageEl.textContent = 'You must consent to receive emails.';
        messageEl.style.color = 'red';
        return;
      }

      // Disable form inputs during submission
      emailInput.disabled = true;
      gdprCheckbox.disabled = true;
      submitBtn.disabled = true;

      try {
        const response = await fetch(API_URL, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ email }),
        });

        const data = await response.json();

        if (response.ok) {
          if (form.classList.contains('code-form')) {
            messageEl.innerHTML = '<p>Thank you for subscribing!</p><p>Use code <strong>ILOVEMUTE</strong> for 10% off your next order.</p>';
            const formHide = form.querySelector('.form-hide');
            const popupTitle = document.querySelector('.popup-title');
            const popupText = document.querySelector('.popup-text');
            const popupCloseForever = document.querySelector('.popup-close-forever');
            formHide.style.display = 'none';
            popupTitle.style.display = 'none';
            popupText.style.display = 'none';
            popupCloseForever.style.display = 'none';
          } else {
            messageEl.textContent = 'Thank you for subscribing!';
          }
        
          messageEl.style.color = '#ff7300';
          messageEl.style.fontWeight = '500';
          messageEl.classList.add('success');

          localStorage.setItem("hidePrimarySubscribe", "yes");
        
          form.reset();
        } else {
          messageEl.textContent = data.message || 'Subscription failed. Please try again.';
          messageEl.style.color = 'red';
        }
      } catch (err) {
        messageEl.textContent = 'An error occurred. Please try again later.';
        messageEl.style.color = 'red';
      } finally {
        // Re-enable form inputs
        emailInput.disabled = false;
        gdprCheckbox.disabled = false;
        submitBtn.disabled = false;
      }
    });
  }

  // Initialize all existing forms on page load
  document.addEventListener('DOMContentLoaded', () => {
    const forms = document.querySelectorAll('.mc-subscribe-form');
    forms.forEach(setupForm);
  });
})();


